import { useLocale } from './locale';
import { translationFeedbackUrl } from '../utils/translationFeedback';

/**
 * Where to send someone who has spotted a bad translation, or nothing when there is nothing for them
 * to report, which is what hides the link for a reader of the English source.
 *
 * Deliberately reads only the resolved locale and not the Localization flag. LocalizationProvider
 * already answers en-US for a user the flag is switched off for, so a flag check would decide the
 * same thing twice and let the two answers drift apart.
 */
export function useTranslationFeedbackHref(): string | undefined {
  return translationFeedbackUrl(useLocale());
}
